import React from "react";
import { useSelector } from "react-redux";
import { Row, Col, CardDeck } from "react-bootstrap";
import CrewCard from "./CrewCard";
import CrewFilteredList from "./CrewFilteredList";

const CrewList = (props) => {
  const crewListById = useSelector((state) => state.dashboard.crew.crewListById.filteredPayload);
  const isRequesting = useSelector((state) => state.dashboard.crew.crewListById.isRequesting);
  const selectedPlanTypeIds = useSelector((state) => state.dashboard.crew.selectedPlanTypeIds);
  const selectedCrewIds = useSelector((state) => state.dashboard.crew.selectedCrewIds);
  const selectedCrewList = [];

  selectedCrewIds.forEach((id) => {
    if (crewListById[id]) selectedCrewList.push(crewListById[id]);
  });
  const filteredCrewList = selectedCrewList.filter((e) => selectedPlanTypeIds.indexOf(e.plan_type_id) >= 0);

  const noActiveCrewFound = Object.keys(crewListById).length === 0 ? false : filteredCrewList.length === 0 && Object.keys(crewListById).filter((id) => crewListById[id].display_order === 1).length === 0;

  return (
    <Row className={`crew-item-list ${(filteredCrewList.length === 0 || isRequesting) && "align-items-center"}`}>
      {filteredCrewList.length === 0 || isRequesting ? (
        <Col className="no-item-found">{isRequesting ? "Loading..." : noActiveCrewFound && selectedPlanTypeIds.length !== 0 ? "No active crews found" : "No Records Found"}</Col>
      ) : (
        <Col className="p-0">
          <CrewFilteredList />
          <Row className="m-0">
            <CardDeck className="my-0 mx-2">
              {filteredCrewList.map((item) => (
                <CrewCard key={item.crew_uuid} item={item} />
              ))}
            </CardDeck>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default CrewList;
